<template>
  <div>
    <button @click="resetRandom">Reset with Random Data</button>
    <button @click="resetZero">Reset to Zero</button>
  </div>
</template>

<script>
import { db } from '../main'

export default {
  name: 'WordCloudReset',
  methods: {
    resetRandom: function() {
      let data = {};
      for (var i = 0; i < 26; i++) {
        data[i] = Math.floor(Math.random()*12);
      }
      data['total'] = 12;
      console.log(data);
      db.collection("enow-cloud").doc("LnLHuCUUzFihi4Ni80yn").set(data)
    },
    resetZero: function() {
      let data = {};
      for (var i = 0; i < 26; i++) {
        data[i] = 0;
      }
      data['total'] = 0;
      console.log(data);
      db.collection("enow-cloud").doc("LnLHuCUUzFihi4Ni80yn").set(data)
    },
    doNothing: function() {}
  },
}
</script>


<style>

button {
  margin: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/WordCloudReset.vue